import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Auth from "@aws-amplify/auth";
import { isEmpty } from "lodash";

import { Hidden, withStyles } from "@material-ui/core";

import {
  updateSession,
  deleteAuth,
  clearSignup,
  openSnackbar
} from "../../store/action-creators";
// entities
import {
  Auth as AuthEntity,
  Session,
  Signup as SignupEntity,
} from "../../entities/auth";
import { Mortgage } from "../../entities/profile";
// components
import HeaderNav from "./HeaderNav";
import ActionButton from "../buttons/ActionButton";
import Login from "../../pages/auth/components/Login";
import Signup from "../../pages/auth/components/Signup";
import ConfirmCode from "../../pages/auth/components/ConfirmCode";
import ForgotPassword from "../../pages/auth/components/ForgotPassword";

import MobileMenu from "./MobileMenu";

import HasAccess from '../auth/HasAccess';
import { Roles } from '../../services/auth';

// icons
import DateRangeIcon from "@material-ui/icons/DateRange";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

const logo = process.env.PUBLIC_URL + "/galilaio/img_logo.svg";

const styles = (theme: any) => ({
  container: {
    backgroundColor: "#fff",
    // borderBottom: '2px solid #C0EAF2'
    height: 75,
    width: "100%",
    borderBottom: "1px solid rgba(0, 171, 202, 0.25)",
    padding: "0px 55px",
    [theme.breakpoints.only("sm", "md")]: {
      padding: "0px 20px !important",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0px 15px !important",
    },
    // paddingLeft: 60,
    // paddingRight: 60
  },

  headerContainer: {
    justifyContent: "space-between",
    display: "flex",
    overFlow: "hidden",
    padding: "0px",
    // margin: '0px auto',
    // width: '80%'
  },

  leftContainer: {
    display: "flex",
  },
  rightContainer: {
    display: "flex",
  },
  logoContainer: {
    padding: 5,
  },
  logoNameContainer: {
    paddingTop: 17,
  },
  logo: {
    width: 151,
    height: 41,
    cursor: "pointer",
    marginTop: 14,
  },
  logoName: {
    height: 25,
    cursor: "pointer",
  },
  address: {
    paddingTop: 20,
    paddingRight: 10,
    textDecoration: "underline",
  },
  addressMobile: {
    marginTop: 10,
    marginRight: 10,
    textDecoration: "underline",
  },
  link: {
    color: "#00ABCA",
    fontSize: 16,
    marginRight: 30.5,
    paddingTop: 27,
    display: "flex",
    alignItems:'center'
  },
  linkicon: {
    marginRight: 7,
  },
  linkMobile: {
    color: "#00ABCA",
    marginRight: 15,
    marginTop: 10,
    marginLeft: 10,
  },
  button: {
    marginTop: 20,
  },
  menuContainer: {
    marginTop: 10,
  },
});

interface HeaderProps {
  match?: any;
  history: any;
  signup: SignupEntity;
  auth: AuthEntity;
  session: Session;
  showOption: boolean;
  openSignup?: boolean;
  openForgotPassword?: boolean;
  onAction?(action: string, route: string): void;
  clearSignup(): void;
  deleteAuth(): void;
  onRefresh(): void;
  onLogin(): void;
  updateSession(session: Session): void;
}

interface HeaderState {
  showLogin: boolean;
  showSignup: boolean;
  showConfirmCode: boolean;
  showForgotPassword: boolean;
}

class Header extends React.Component<HeaderProps, HeaderState> {
  state = {
    showLogin: false,
    showSignup: false,
    showConfirmCode: false,
    showForgotPassword: false,
  };

  componentDidMount = () => {
    // if (this.props.history.location.pathname === '/' || this.props.history.location.pathname === '/home') {
    //   this.setState({showOption: false})
    // }
  };

  componentWillUpdate = (prevProps: HeaderProps, prevState: HeaderState) => {
    if (prevProps.openSignup !== this.props.openSignup) {
      this.setState({ showSignup: true });
    }
    if (prevProps.openForgotPassword !== this.props.openForgotPassword) {
      this.setState({ showForgotPassword: true });
    }
  };

  onLogoClick = () => {
    if(isEmpty(this.props.auth)){
      const newSession = this.props.session;
      newSession.payment = 0;
      newSession.page = "/";
      this.props.updateSession(newSession);
      this.props.history.push("/");
    }
    else {
      this.props.history.push("/campaigns");
    }
  };

  onNavigate = (route: string) => {
    if (route === "logout") {
      this.props.deleteAuth();
      this.props.history.push("/");
    } else {
      this.props.history.push(route);
    }
  };

  updatePayment = (payment: number) => {
    // update session
    const newSession = this.props.session;
    newSession.payment = payment;
    this.props.updateSession(newSession);
    // goto options page
    if (
      this.props.history.location.pathname === "/options" &&
      this.props.onRefresh !== undefined
    ) {
      this.props.onRefresh();
    } else {
      this.props.history.push("/options");
    }
  };

  handleSignIn = () => {
    // sign in
    this.setState({ showLogin: true });
  };

  handleSignUp = () => {
    // sign up
    this.setState({ showSignup: true });
  };

  handleClose = (route?: string) => {
    if (!route) {
      this.setState({
        showLogin: false,
        showSignup: false,
        showConfirmCode: false,
        showForgotPassword: false
      });
      if (this.props.onAction) {
        this.props.onAction('close', '');
      }
      return;
    }

    if (route === "confirm") {
      this.setState({
        showLogin: false,
        showSignup: false,
        showConfirmCode: true,
        showForgotPassword: false
      });
    } else if (route === "signup") {
      this.setState({
        showLogin: false,
        showSignup: true,
        showConfirmCode: false,
        showForgotPassword: false
      });
    } else if (route === "login") {
      this.setState({
        showLogin: true,
        showSignup: false,
        showConfirmCode: false,
        showForgotPassword: false
      });
    } else if (route === "forgot") {
      this.setState({
        showLogin: false,
        showSignup: false,
        showConfirmCode: false,
        showForgotPassword: true
      });
    } else {
      this.setState({
        showLogin: false,
        showSignup: false,
        showConfirmCode: false,
        showForgotPassword: false,
      });
      this.props.history.push(route);
    }
  };

  handleFinishSignup = () => {
    const tmpAuth =
      !isEmpty(this.props.signup) &&
        !isEmpty(this.props.signup.email) &&
        isEmpty(this.props.signup.username)
        ? true
        : false;
    if (tmpAuth) {
      this.setState({
        showSignup: true,
      });
    } else {
      this.setState({
        showConfirmCode: true,
      });
    }
  };

  handleLogout = async () => {
    this.props.clearSignup();
    this.props.deleteAuth();
    const newSession = this.props.session;
    newSession.address = undefined;
    newSession.selectedMortgage = {} as Mortgage;
    this.props.updateSession(newSession);
    await Auth.signOut();
    this.props.history.push("/");
  };

  handleAddressClick = () => {
    if (this.props.session.address) {
      this.props.history.push(
        `/payment-design-center/${this.props.session.address.id}`
      );
    }
  };

  handleCampaignClick = () => {
    this.props.history.push(`/profile`);
  };

  render() {
    const showOption =
      this.props.showOption !== undefined ? this.props.showOption : true;
    const address = this.props.session.address
      ? this.props.session.address.address
      : "";
    const { classes }: any = this.props;
    return (
      <div className={`header-container ${classes.container}`}>
        <div className={`header-headercontainer ${classes.headerContainer}`}>
          <div className={classes.leftContainer}>
            <Hidden smDown>
              <div className={classes.logoContainer}>
                <img
                  src={logo}
                  className={classes.logo}
                  onClick={this.onLogoClick}
                />
              </div>
            </Hidden>
            <Hidden mdUp>
              <div className={classes.logoContainer}>
                <img
                  src={logo}
                  style={{ marginTop: 14, height: 30, cursor: "pointer" }}
                  onClick={this.onLogoClick}
                />
              </div>
            </Hidden>
          </div>
          <div>
            <div className={classes.rightContainer}>
              {isEmpty(this.props.signup) && isEmpty(this.props.auth) && (
                <div style={{ display: "flex" }}>
                  <Hidden smDown>
                    <div className={classes.link}>
                      <ActionButton
                        textOnly
                        name="Contact"
                        onClick={() => this.onNavigate("/contact")}
                      />
                    </div>
                    <div className={classes.link}>
                      <ActionButton
                        textOnly
                        name="Sign In"
                        onClick={this.handleSignIn}
                      />
                    </div>
                    <div className={classes.button}>
                      <ActionButton
                        size="sm"
                        name="Create Campaign"
                        onClick={() => this.onNavigate("/campaign/new/details")}
                      />
                    </div>
                  </Hidden>
                  <Hidden mdUp>
                    <div style={{ marginTop: 5 }}>
                      <MobileMenu onClick={this.onNavigate} />
                    </div>
                  </Hidden>
                </div>
              )}
              {isEmpty(this.props.auth) && !isEmpty(this.props.signup) && (
                <div style={{ display: "flex" }}>
                  <Hidden smDown>
                    <div className={classes.address}>{address}</div>
                    <div className={classes.link}>
                      <ActionButton
                        textOnly
                        name="Finish Signup"
                        onClick={this.handleFinishSignup}
                      />
                    </div>
                  </Hidden>
                  <Hidden mdUp>
                    <div className={classes.addressMobile}>{address}</div>
                    <div className={classes.linkMobile}>
                      <ActionButton
                        textOnly
                        name="Finish Signup"
                        onClick={this.handleFinishSignup}
                      />
                    </div>
                  </Hidden>
                </div>
              )}
              {!isEmpty(this.props.auth) && (
                <div>
                  <Hidden smDown>
                    <div style={{ display: "flex" }}>
                      <div className={classes.link}>
                        <ActionButton
                          textOnly
                          name={address}
                          onClick={this.handleAddressClick}
                        />
                      </div>
                      <HasAccess roles={[Roles.user]} notRoles={[Roles.textadmin]}>
                        <div className={classes.link}>
                          <DateRangeIcon className={classes.linkicon} />
                          <ActionButton
                            textOnly
                            name="Campaigns"
                            onClick={() => this.onNavigate("/campaigns")}
                          />
                        </div>
                      </HasAccess>
                      <HasAccess roles={[Roles.textadmin]}>
                        <div className={classes.link}>
                          <DateRangeIcon className={classes.linkicon} />
                          <ActionButton
                            textOnly
                            name="Run Campaigns"
                            onClick={() => this.onNavigate("/admin/campaigns/run")}
                          />
                        </div>
                      </HasAccess>
                      <div className={classes.link}>
                        <AccountCircleIcon className={classes.linkicon} />
                        <ActionButton
                          textOnly
                          name="Profile"
                          onClick={this.handleCampaignClick}
                        />
                      </div>
                      <div className={classes.link}>
                        <ExitToAppIcon className={classes.linkicon} />
                        <ActionButton
                          textOnly
                          name="Log Out"
                          onClick={this.handleLogout}
                        />
                      </div>
                    </div>
                  </Hidden>
                  <Hidden mdUp>
                    <div
                      style={{ display: "flex", marginRight: 5, marginTop: 6 }}
                    >
                      <div
                        className={`link ${classes.addressMobile}`}
                        onClick={this.handleAddressClick}
                      >
                        {address}
                      </div>
                      <HeaderNav
                        onLogin={this.props.onLogin}
                        onNavigate={this.onNavigate}
                        path={this.props.match.path}
                        onLogout={this.handleLogout}
                      />
                    </div>
                  </Hidden>
                </div>
              )}
            </div>
          </div>
        </div>
        <Login open={this.state.showLogin} onClose={this.handleClose} />
        <Signup open={this.state.showSignup} onClose={this.handleClose} />
        <ConfirmCode open={this.state.showConfirmCode} onClose={this.handleClose} />
        <ForgotPassword open={this.state.showForgotPassword} onClose={this.handleClose} />   
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    signup: state.auth.signup,
    auth: state.auth.auth,
    session: state.session.session,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    { updateSession, deleteAuth, clearSignup },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(withStyles(styles)(Header)));



// WEBPACK FOOTER //
// ./src/components/header/Header.tsx